import { app, Component, ojs } from "modular-openscriptjs";
import { pageInfo, redirect } from "../../helpers";
import { PAGES } from "../../declarations";
import LoginOptions from "../Blocks/LoginOptions";

const h = app("h");

ojs(LoginOptions);

export default class LoginPage extends Component {
	render(...args) {
		pageInfo(PAGES.LOGIN);

		return h.div(
			{
				class: "min-vh-100 d-flex align-items-center justify-content-center bg-light py-md-5",
			},
			h.div(
				{
					class: "card border-0 shadow-sm p-4 p-md-5",
					style: "max-width: 450px; width: 100%; border-radius: 20px;",
				},

				// Header
				h.div(
					{ class: "text-center mb-4" },
					h.h2(
						{ class: "fw-bold mb-2", style: "color: #010101;" },
						"Welcome Back"
					)
				),

				// Google / Apple / Email options + "Create Account" - shared
				// with the LoginModal guests see (components/Blocks/LoginOptions.js).
				h.LoginOptions({ idPrefix: "login" }),

				// Back to Home
				h.div(
					{ class: "text-center mt-4" },
					h.a(
						{
							href: "#",
							class: "text-muted small text-decoration-none fw-500",
							onclick: "app('router').to('home')",
						},
						"← Back to Home"
					)
				)
			),
			...args
		);
	}

	$$user = {
		authenticated: (ed, event) => {
			if (app("router").is("user.login")) {
				redirect().to("index");
			}
		},
	};
}

ojs(LoginPage);
